
/*
    Filter for the Quarterly Report,
    with a start date, end date, and the option to reset
*/

import React from "react";

import MainContext from "../MainContext";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

/*
Start Date
End Date
*/

export default class ReportQuarterlyFilter extends React.Component {

    static contextType = MainContext;

    state = {
        startDate: new Date(),
        endDate: new Date()
    }

    setStartDate = (date) => {
        this.setState({startDate: date});
    }

    setEndDate = (date) => {
        this.setState({endDate: date});
    }

    applyFilter = () => {
        const values = {...this.state};
        
        this.props.applyFilter(values, this.props.toggleFilter);
        this.context.updateReportFilter(values);
    }

    resetFilter = () => {
        this.setState({startDate: new Date(), endDate: new Date()});
    }

    //
    // set the filter values
    //
    componentDidMount(){
        console.log("REPORT STARTER FILTER MOUNT", this.context);

        // if we had previously used this filter, those values
        // can be retrieved and placed

        if(this.props.filterValues){
            this.setState({...this.props.filterValues});
        }
        else if(this.context.reportFilterValues){
            console.log("WE HAVE REPORT VALUES", this.context.reportFilterValues);
            const copy = {...this.state};
            for(let key in copy) {
                if(this.context.reportFilterValues.hasOwnProperty(key)){
                    copy[key] = this.context.reportFilterValues[key];
                }
            }
            this.setState(copy);
        }
    }

    render(){
        return (
            <div className="filter">
                <div className="filter-field form-element-horizontal">
                    <label>Start Date</label>
                    <DatePicker 
                        selected={this.state.startDate} 
                        onChange={date => this.setStartDate(date)} 
                    />
                </div>
                <div className="filter-field form-element-horizontal">
                    <label>End Date</label>
                    <DatePicker 
                        selected={this.state.endDate} 
                        onChange={date => this.setEndDate(date)} 
                    />
                </div>
                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        )
    }
}